import styled from "styled-components";

export const Container = styled.button`
  z-index: 9999999;
  display: flex;
  align-items: center;
  padding: 20px !important;
  gap: 10px;
  width: auto;
  height: 40px;
  position: fixed;
  bottom: 40px;
  border-radius: 0 !important;
  font-weight: 700px;
  right: 20px;
  box-shadow: 0px 3px 15px rgba(100, 114, 140, 0.3);
  margin: 0;
  background-color: var(--primary-color);

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 0 20px;
    gap: 18px;
  }

  img {
    width: 25px;
  }

  span {
    font-size: 14px;
  }
`;
